import React from 'react'
import './css/about.css'
import a from './css/profile.jpg'

const About = () => {
  return (
    <div className='conatiner'>
      <div className='card_container'>
        <div className="card" >
          <img src={a} className="card-img-top" alt="..." />
          <div className="card-body">
            <h2 className='heading'>Simrat Singh</h2>
            <span className='text-dark'>Lovely Professional University</span>
           
          </div>
        </div>
       
      
      </div>
    </div>
  )
}

export default About